import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environmentCircuits } from 'src/environments/circuits/environment';
import { init, browserTracingIntegration } from '@sentry/angular-ivy';
import { AppModule } from './app/app.module';
import { brandName } from './app/shared/utils/configSource';

if (environmentCircuits.production) {
  init({
    dsn: 'https://a1d5cc8e6f0d3905a4749aa39124cc6c@o4507102420402176.ingest.us.sentry.io/4507102429708288',
    integrations: [
      browserTracingIntegration({
        tracingOrigins: ['https://app-dev.wisen.com.br'],
      }),
    ],
    tracesSampleRate: 1.0,
    beforeSend(event, hint) {
      const error: any = hint?.originalException;
      const isHttpError = error && (error.name === 'HttpErrorResponse' || error.status !== undefined);
      // Ignora falhas de rede do cliente (timeout, offline, CORS bloqueado, etc)
      if (isHttpError && error.status === 0) {
        return null;
      }
      // Ignora respostas de auth/permissão do backend (não são bugs do cliente)
      if (isHttpError && (error.status === 401 || error.status === 403)) {
        return null;
      }
      return event.level === 'error' || event.level === 'fatal' ? event : null;
    },
  });

  enableProdMode();
}

document.title = brandName;

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));


